import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select, { components } from "react-select";

// base styles
import colors from "assets/theme/base/colors";

// Custom styles for SoftSelectField
import styles from "components/SoftSelect/styles";
import { useLocation, useParams } from "react-router-dom";

const SoftSelectField = forwardRef(
  ({ size, width, border, borderColor, error, success, ...rest }, ref) => {
    const {
      options,
      field,
      form: { setFieldValue, ...formRest },
      value,
    } = rest;
    const { light } = colors;

    const { id } = useParams();
    const location = useLocation();
    const containEdit = location.pathname?.includes("/edit");
    const disabled = id && !containEdit;

    return (
      <Select
        {...rest}
        ref={ref}
        placeholder="Chọn..."
        components={{ NoOptionsMessage }}
        isDisabled={disabled}
        styles={styles(size, error, success, width, border, borderColor, disabled)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: light.main,
            primary: light.main,
          },
        })}
        options={options}
        name={field.name}
        onChange={(option) => setFieldValue(field.name, option.value)}
        onBlur={field.onBlur}
        value={
          options ? (value.toString() ? options.find((option) => option.value == value) : "a") : "b"
        }
      />
    );
  }
);

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      <span>Không có kết quả nào</span>
    </components.NoOptionsMessage>
  );
};

// Setting default values for the props of SoftSelectField
SoftSelectField.defaultProps = {
  size: "medium",
  error: false,
  success: false,
  width: "100%",
  border: "",
  borderColor: "",
};

// Typechecking props for the SoftSelectField
SoftSelectField.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  width: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  border: PropTypes.string,
  borderColor: PropTypes.string,
};

export default SoftSelectField;
